
import "./styles/crew.css";
import { useState } from "react";
import useFetch from "./usefetch";

import one from './assets/crew/image-douglas-hurley.webp'
import two from "./assets/crew/image-mark-shuttleworth.webp"
import three from "./assets/crew/image-victor-glover.webp"
import four from "./assets/crew/image-anousheh-ansari.webp"



const Crew = () => {

    const images = [one, two, three, four]
    
    const {dataCrew,error} = useFetch('data.json')
    const [crew, setCrew] = useState(0);

    const checkedInput = (e) => {
        const inputList = document.querySelectorAll('input[type="checkbox"]');
        inputList.forEach((input) => {
            input.checked = false;
            input.parentElement.classList.remove('active');
        })

        e.target.parentElement.classList.add('active')
    }


    return ( 
<>
   { error && <div>{error}</div>}
   {dataCrew && <div className="crewPage">
            <div className="crewContent">
                <div className="crewInfo">
                <p className="tagLine"><span className="tag">02</span>MEET YOUR CREW</p>

                <section className="info">
                            <span className="post">{(dataCrew[crew].role).toUpperCase()}</span>
                            <h1 className="name">{dataCrew[crew].name}</h1>
                    <article>
                        <p className="about">
                            {dataCrew[crew].bio}
                        </p>
                    </article>
                </section>
                <aside className="selectionButtons">
                        <label htmlFor="one" className="active">
                            <input type="checkbox" id="one" value="0" onChange={e => {
                                        checkedInput(e)
                                        setCrew(e.target.value)
                                    }} />
                        </label>
                        <label htmlFor="two">
                            <input type="checkbox" id="two" value="1" onChange={e => {
                                        checkedInput(e)
                                        setCrew(e.target.value)
                                    }} />
                        </label>
                        <label htmlFor="three">
                            <input type="checkbox" id="three" value="2" onChange={e => {
                                        checkedInput(e)
                                        setCrew(e.target.value)
                                    }} />
                        </label>
                        <label htmlFor="four">
                            <input type="checkbox" id="four" value="3" onChange={e => {
                                        checkedInput(e)
                                        setCrew(e.target.value)
                                    }} />
                        </label>
                </aside>
            </div>
            <div className="crewManPicture">
                <img src={images[crew]} alt={dataCrew[crew].name} />
            </div>
            </div>
        </div> }
</>
     );
}
 
export default Crew;